import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Fill, Icon, Stroke, Style } from 'ol/style';
import { fromLonLat } from 'ol/proj';
import { Feature, Overlay } from 'ol';
import { Point, Polygon } from 'ol/geom';
import { MapService } from './map.service';
import { WebsocketService } from '../../../services/websocket.service';
import { privateApiUrl } from '../../../private/private-apiUrl';
import { WebSocketApiUrl } from '../../../constant/websocket-apiUrl';
import { DeviceMapResponse, Legends, TokenExpired } from './map';
import { ConstantValue } from '../../../constant/constant-value';
import _, { cloneDeep } from 'lodash';
import Cluster from 'ol/source/Cluster';
import { Circle as CircleStyle, Text } from 'ol/style';
import { DeviceCardInfo } from '../../../private/dashboard/dashboard/dashboard';
@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    providers: [MapService],
})
export class MapComponent implements OnInit, OnDestroy {
    @Output() deviceCardInfo = new EventEmitter<DeviceCardInfo>();

    map!: Map;
    vectorSource!: VectorSource;
    vectorLayer!: VectorLayer;
    clusterLayer!: VectorLayer;
    markerList: DeviceMapResponse[] = [];
    allMapResponse: DeviceMapResponse[] = [];
    popUpOverLay!: Overlay;
    popUpCloseIcon!: HTMLElement;
    isMapLoaded = false;
    legendsList: Legends[] = [];
    noLocationCount = 0;
    isInitialLoad = true;
    hasNoDevice = false;

    constructor(
        private mapService: MapService,
        private webSocketService: WebsocketService
    ) {}

    ngOnInit() {
        this.onWebSocket();
    }

    onWebSocket() {
        this.webSocketService.getWebSocketToken(privateApiUrl.WEB_SOCKET_TOKEN, ConstantValue.MAP_WEBSOCKET_TOKEN).then((response: any) => {
            if (response) {
                this.webSocketService.connect(WebSocketApiUrl.WEB_SOCKET_MAP_API, response);
                this.createMap();
                this.webSocketService.getMessages().subscribe((response: DeviceMapResponse[]) => {
                    const deviceInfo = { totalParameter: 0, deviceOnlineCount: 0, deviceOfflineCount: 0 };
                    if (response.length > 0) {
                        deviceInfo.totalParameter = response.length;
                        deviceInfo.deviceOnlineCount = _.filter(response, status => status.device_active_status).length;
                        deviceInfo.deviceOfflineCount = response.length - deviceInfo.deviceOnlineCount;
                    }
                    this.deviceCardInfo.emit(deviceInfo);
                    this.allMapResponse = cloneDeep(response);
                    this.hasNoDevice = false;

                    if (this.allMapResponse && this.allMapResponse.length > 0) {
                        this.markerList = [];
                        this.markerList = this.allMapResponse;
                        this.onMapData();
                    }
                });

                this.webSocketService.getMessages().subscribe((response: TokenExpired) => {
                    // if (response && response.code === 1011) {
                    //     this.publicService.logOut().then(response => {
                    //         if (response.code >= 1000 && response.code < 2000) {
                    //             this.onLogoutSuccess();
                    //             this.snackbarService.successSnackBar(response.message);
                    //         } else {
                    //             this.snackbarService.errorSnackBar(response.message);
                    //         }
                    //     });
                    // }
                });
            }
        });
    }

    onMapData() {
        if (this.markerList && this.markerList.length > 0) {
            this.addMultipleMarker(this.markerList);
        } else {
            this.vectorSource.clear();
        }
    }

    onLogoutSuccess() {
        // this.router.navigate([NavigationUrl.LOGIN]);
        // const theme = LocalStorageUtility.getTheme() as string;
        // sessionStorage.clear();
        // LocalStorageUtility.setTheme(theme);
    }

    createMap() {
        const geoJsonUrl = 'assets/geo-json-files/india-boundary.geojson';
        this.blurOutsideBoundary(geoJsonUrl);

        // Below statement will get the div of the popup
        const container = document.getElementById('popup');
        this.popUpCloseIcon = document.getElementById('popup-closer') as HTMLElement;
        if (container) {
            this.createTheInfoPopUp(container);
            this.initializeMap();
        }
    }

    createTheInfoPopUp(container: HTMLElement) {
        this.popUpOverLay = new Overlay({
            element: container,
            autoPan: {
                animation: {
                    duration: 250,
                },
            },
        });
        this.closeIconAction();
    }

    closeIconAction() {
        this.popUpCloseIcon.addEventListener('click', () => {
            this.popUpOverLay.setPosition(undefined);
            this.popUpCloseIcon.blur();
            return false;
        });
    }

    addMultipleMarker(locations: DeviceMapResponse[]) {
        this.vectorSource.clear();
        this.legendsList = [];

        locations.forEach(location => {
            if (!location.device_longitude || !location.device_latitude) {
                if (this.isInitialLoad) {
                    this.noLocationCount++;
                }
                return;
            }
            this.addMarker(location);

            const existingLegend = this.legendsList.find(
                legend => legend.modelName === location.device_model && legend.deviceStatus === location.device_active_status
            );

            if (existingLegend) {
                ++existingLegend.count;
            } else {
                if (location.device_model) {
                    this.legendsList.push({
                        modelName: location.device_model as string,
                        icon: `assets/icons/map-icons/${location.device_model}-${location.device_active_status}.png`,
                        deviceStatus: location.device_active_status,
                        count: 1,
                    });
                } else {
                    this.legendsList.push({
                        modelName: location.device_model as string,
                        icon: `assets/icons/map-icons/no-model.svg`,
                        deviceStatus: location.device_active_status,
                        count: 1,
                    });
                }
            }
        });

        if (!this.isMapLoaded) {
            const extent = this.vectorSource.getExtent();

			if (extent) {
			  this.map.getView().fit(extent, { padding: [50, 50, 50, 50] });
			}
            const currentZoom: any = this.map.getView().getZoom();
            if (currentZoom > 12) {
                this.map.getView().setZoom(12);
            }
            this.isMapLoaded = true;
        }

        if (this.isInitialLoad) {
            this.isInitialLoad = false;
        }
    }

    addMarker(location: DeviceMapResponse) {
        const marker = new Feature({
            geometry: new Point(fromLonLat([location.device_longitude as number, location.device_latitude as number])),
            device_id: { key: 'Device ID', value: location.device_id },
            device_name: { key: 'Device Name', value: location.device_name },
            device_model: { key: 'Device Model', value: location.device_model },
            device_last_reading_date: { key: 'Last Reading Date', value: location.device_last_reading_time },
            device_active_status: { key: 'Device Status', value: location.device_active_status },
        });

        marker.setStyle(
            new Style({
                image: new Icon({
                    anchor: [0.5, 0.5],
                    src: this.getImageUrl(location),
                    scale: 0.5,
                }),
            })
        );
        this.vectorSource.addFeature(marker);
    }

    getImageUrl(location: DeviceMapResponse) {
        if (location.device_model) {
            return `assets/icons/map-icons/${location.device_model}-${location.device_active_status}.png`;
        } else if (location.device_model && (!location.device_longitude || !location.device_latitude)) {
            return `assets/icons/map-icons/no-location.svg`;
        } else {
            return `assets/icons/map-icons/no-model.svg`;
        }
    }

    getFeatureImageUrl(location: any) {
        let imageSrc = `assets/icons/map-icons/no-model.svg`;
        if (location.get('device_model')) {
            imageSrc = `assets/icons/map-icons/${location.get('device_model').value}-${location.get('device_active_status').value}.png`;
        }

        return new Style({
            geometry: location.getGeometry(),
            image: new Icon({
                src: imageSrc,
                scale: 0.5,
            }),
        });
    }

    blurOutsideBoundary(geoJsonUrl: string) {
        this.mapService.getGeoJSONData(geoJsonUrl).then(geoJsonData => {
            // Read features from GeoJSON
            const boundaryFeatures = new GeoJSON().readFeatures(geoJsonData, {
                featureProjection: 'EPSG:3857',
            });
            const worldPolygon = new Feature({
                geometry: new Polygon([
                    [
                        [-20037508.34, -20037508.34], // Bottom-left (EPSG:3857 bounds)
                        [-20037508.34, 20037508.34], // Top-left
                        [20037508.34, 20037508.34], // Top-right
                        [20037508.34, -20037508.34], // Bottom-right
                        [-20037508.34, -20037508.34], // Close ring
                    ],
                ]),
            });

            // Subtract the boundary polygon from the world polygon to create a mask
            boundaryFeatures.forEach(boundaryFeature => {
                const geometry = boundaryFeature.getGeometry();
                if (geometry && geometry.getType() === 'Polygon') {
                    const polygon = geometry as Polygon;
                    const rings = polygon.getLinearRings();
                    rings.forEach(ring => {
                        (worldPolygon.getGeometry() as Polygon).appendLinearRing(ring);
                    });
                } else if (geometry && geometry.getType() === 'MultiPolygon') {
                    const multiPolygon = geometry as any;
                    const polygons = multiPolygon.getPolygons();
                    polygons.forEach((polygon: any) => {
                        const rings = polygon.getLinearRings();
                        rings.forEach((ring: any) => {
                            (worldPolygon.getGeometry() as Polygon).appendLinearRing(ring);
                        });
                    });
                }
            });
            const maskSource = new VectorSource({
                features: [worldPolygon],
            });

            const maskLayer = new VectorLayer({
                source: maskSource,
                style: new Style({
                    fill: new Fill({
                        color: 'rgba(0, 0, 0, 0.5)',
                    }),
                }),
            });

            this.map.addLayer(maskLayer);
            // const boundarySource = new VectorSource({ features: boundaryFeatures });
            // this.map.getView().fit(boundarySource.getExtent(), { padding: [50, 50, 50, 50] });
        });
    }

    initializeMap() {
        const initialLonLat = [78.9629, 20.5937];
        const initialWebMercator = fromLonLat(initialLonLat);
        this.vectorSource = new VectorSource();

        this.vectorLayer = new VectorLayer({
            source: this.vectorSource,
        });

        const clusterSource = new Cluster({
            distance: 100,
            minDistance: 50,
            source: this.vectorSource,
        });

        const styleCache: { [key: string]: Style | Style[] } = {};

        const textColor = 'rgb(244, 244, 244)';
        this.clusterLayer = new VectorLayer({
            source: clusterSource,
            style: feature => {
                const size = feature.get('features').length;

                if (size > 1) {
                    let style = styleCache[size];
                    if (!style) {
                        style = new Style({
                            image: new CircleStyle({
                                radius: 10,
                                fill: new Fill({ color: this.mapService.setTheClusterColors(1) }),
                                stroke: new Stroke({ color: this.mapService.setTheClusterColors(0.6), width: 4 }),
                            }),
                            text: new Text({
                                text: size.toString(),
                                fill: new Fill({ color: `${textColor}` }),
                            }),
                        });
                        const ripple1 = new Style({
                            image: new CircleStyle({
                                radius: 15,
                                stroke: new Stroke({ color: this.mapService.setTheClusterColors(0.4), width: 4 }),
                            }),
                        });

                        const ripple2 = new Style({
                            image: new CircleStyle({
                                radius: 20,
                                stroke: new Stroke({ color: this.mapService.setTheClusterColors(0.2), width: 4 }),
                            }),
                        });
                        styleCache[size] = [ripple2, ripple1, style];
                    }
                    return style;
                }

                const originalFeature = feature.get('features')[0];
                return this.getFeatureImageUrl(originalFeature);
            },
        });

        this.map = new Map({
            target: 'map',
            layers: [
                new TileLayer({
                    source: new OSM(),
                }),
                this.clusterLayer,
            ],
            overlays: [this.popUpOverLay],
            view: new View({
                center: initialWebMercator,
                zoom: 10,
            }),
        });

        this.map.on('singleclick', (evt: any) => {
            const isDeviceMarked = this.map.forEachFeatureAtPixel(evt.pixel, feature => {
                return feature;
            });
            if (isDeviceMarked) {
                const geometry = isDeviceMarked.getGeometry() as Point;
                const coordinates = geometry.getCoordinates();
                const content = document.getElementById('popup-content') as HTMLElement;
                const featureData = isDeviceMarked.getProperties()['features'][0];
                const deviceActiveStatus = featureData.get('device_active_status').value ? 'online' : 'offline';
                content.innerHTML =
                    `<h1>${featureData.get('device_id').key}: </h1><p>${featureData.get('device_id').value}</p><br>` +
                    `<h1>${featureData.get('device_name').key}: </h1><p>${featureData.get('device_name').value}</p><br>` +
                    `<h1>${featureData.get('device_model').key}: </h1><p>${featureData.get('device_model').value}</p><br>` +
                    `<h1>${featureData.get('device_last_reading_date').key}: </h1><p>${featureData.get('device_last_reading_date').value}</p><br>` +
                    `<h1>${featureData.get('device_active_status').key}: </h1><mat-chip class="${deviceActiveStatus}">${featureData.get('device_active_status').value ? 'Online' : 'Offline'}</mat-chip><br>`;
                this.popUpOverLay.setPosition(coordinates);
            }
        });
    }

    ngOnDestroy(): void {
        this.webSocketService.closeConnection();
    }
}
